export default function RaListToolbar(theme): object {
  return {
    RaListToolbar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
          [theme.breakpoints.up('xs')]: {
            padding: theme.spacing(2),
          },
          '& .MuiToolbar-root': {
            alignItems: 'center',
          },
        },
      },
    },
  }
}
